
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-compatibility-helpers/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-destroyable-polyfill/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
